<template>
  <div class="help">
    <!--导航栏-->
    <header-nav></header-nav>
    <!--个人中心导航-->
    <!--    <user-nav></user-nav>-->
    <div class="user-center">
      <el-tabs class="border-card-main" type="border-card">
        <el-tab-pane label="代发指南">
          <div class="content">
            <div class="help-list noSelect">
              <div class="help-item" v-for="(item, index) in helpList" :key="index" @click="onOpenDetail(item)">
                <div class="help-item-left">
                  <div class="help-index">{{ index + 1 }}</div>
                  <p class="help-title">{{ item.title }}</p>
                </div>

                <a class="course-btn" href="javascript:void(0)">
                  查看教程
                  <img class="next-icon" :src="IMG_URL + 'images/icons/next.png'" alt="" />
                </a>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <!--底部-->
    <footer-box></footer-box>

    <el-dialog :visible.sync="dialogVisible" :before-close="handleClose" :title="detail.title" class="dialog-box" width="60%">
      <div class="news-detail-content" v-html="detail.content"></div>
    </el-dialog>
  </div>
</template>

<script>
import headerNav from "@/components/headerNav/index";
import userNav from "@/components/userNav/index";
import footerBox from "@/components/footerBox/index";
import { apiIndexHelp } from "@/api/api";
export default {
  name: "help",
  components: { headerNav, userNav, footerBox },
  data() {
    return {
      dialogVisible: false,
      detail: {},
    };
  },
  computed: {
    helpList() {
      return this.$store.getters.helpList;
    },
  },
  mounted() {
    this.$store.dispatch("getIndexHelp");
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
      this.detail = {};
    },
    onOpenDetail(item) {
      console.log(item);
      this.detail = item;
      const regex = new RegExp("<img", "gi");
      this.detail.content = this.detail.content.replace(regex, '<img style="max-width: 100%; height: auto;"');
      this.dialogVisible = true;
    },
  },
};
</script>

<style scoped lang="scss">
.help {
  min-height: 100vh;
  position: relative;
  padding-bottom: 80px;
  // background-color: #eeeeee;

  .user-center {
    width: 1300px;
    margin: 0 auto;
    //padding-left: 180px;

    .border-card-main {
      min-height: calc(100vh - 190px);

      .content {
        padding: 20px;

        .help-item {
          margin-bottom: 20px;
          color: #000000;
          font-size: 14px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          background-color: #f2f2f2;
          padding-right: 20px;
          cursor: pointer;

          .help-item-left {
            display: flex;
            align-items: center;

            .help-index {
              width: 60px;
              height: 60px;
              background-color: #0f375a;
              color: #ffffff;
              font-size: 32px;
              text-align: center;
              line-height: 60px;
            }

            .help-title {
              margin-left: 20px;
            }
          }

          .course-btn {
            padding: 2px 10px;
            color: #0f375a;
            font-size: 12px;
            margin-left: 10px;
            display: flex;
            align-items: center;

            .next-icon {
              height: 10px;
              width: auto;
              margin-left: 5px;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/help/index.vue